import { Tooltip } from '@mui/material';
import React from 'react';

import Fg677Icon from '../../../assets/icons/677fg.svg';
import IgreeksIcon from '../../../assets/icons/igreeks-white.svg';
import { BLUR_STYLE } from '../../../providers/demo-blur';
import { Radio } from '../../../components/radio';
import Utils from '../../../utils/immersive_utils';
import { IAccountOption } from '../../../providers/venue-provider';
import './styles.scss';

interface OTCAccountListProps {
  accounts: IAccountOption[];
  isPortfolioSidebarOpen: boolean;
  selectedAccountOption: any;
  handleOptionChange: (account: any) => void;
  isDisabledAccounts: boolean;
  calculatedAccountNames: Set<string>;
  icon: any;
  label: string;
  exchange: string;
  // Opt-in "blur names for demo" (Portfolio Management). Off by default.
  isBlurred?: boolean;
}

export const OTCAccountList: React.FC<OTCAccountListProps> = ({
  accounts,
  isPortfolioSidebarOpen,
  selectedAccountOption,
  handleOptionChange,
  isDisabledAccounts,
  calculatedAccountNames,
  icon,
  label,
  exchange,
  isBlurred = false,
}) => {
  if (!accounts.length) return null;

  const accountsByVenue = accounts.reduce(
    (acc, account) => {
      const venue = account.venue || '';
      if (!acc[venue]) acc[venue] = [];
      acc[venue].push(account);
      return acc;
    },
    {} as Record<string, any[]>,
  );

  return (
    <div className="portfolio-accounts-venue">
      <div className="portfolio-account-label">
        <img src={icon} alt={exchange} />
        <span>{label}</span>
      </div>
      {Object.entries(accountsByVenue).map(([venue, accounts]) => (
        <div key={venue} className="portfolio-otc-accounts-radios-data">
          <div className="otc-venue-title-area">
            <img src={venue === 'igreeks' ? IgreeksIcon : Fg677Icon} alt={exchange} />
            <div className="otc-venue-title" style={isBlurred ? BLUR_STYLE : undefined}>
              {venue}
            </div>
          </div>
          {accounts.map((account, index) => {
            const isCalculated = calculatedAccountNames.has(account.name);
            return (
              <Tooltip
                key={`${account.name}-${index}`}
                title={!isBlurred && account.name.length >= 20 ? account.name : ''}
              >
                <div
                  className={`portfolio-accounts-area-radio ${isPortfolioSidebarOpen && 'radio-hover'}`}
                >
                  <Radio
                    label={
                      <span style={isBlurred ? BLUR_STYLE : undefined}>
                        {Utils.truncateLabel(account.name)}
                      </span>
                    }
                    checked={selectedAccountOption.name === account.name}
                    onChange={() => handleOptionChange(account)}
                    disabled={isDisabledAccounts}
                  />
                  {isPortfolioSidebarOpen && isCalculated && (
                    <div className="portfolio-accounts-circle-calculated" />
                  )}
                </div>
              </Tooltip>
            );
          })}
        </div>
      ))}
    </div>
  );
};
